/* R&B · scheduled sections and links (snippets/rb-when.liquid). Shows or hides [data-rb-when] by the visitor's clock,
   once on load and then every minute, so a page that was cached before the start time still opens on the minute.
   ?rb_preview=1 in the address shows everything (for checking the page before the date). */
(function () {
  if (window.RbWhen) return;
  var preview = /[?&]rb_preview=1(&|$)/.test(location.search);
  function check() {
    var now = Date.now() / 1000;
    var design = window.Shopify && window.Shopify.designMode;
    var changed = false;
    document.querySelectorAll('[data-rb-when]').forEach(function (el) {
      var f = +el.getAttribute('data-rb-from') || 0;
      var u = +el.getAttribute('data-rb-until') || 0;
      var show = design || preview || ((!f || now >= f) && (!u || now < u));
      if (el.hidden === show) { el.hidden = !show; changed = true; }
      if (el.getAttribute('data-rb-when') === 'section') {
        var w = el.closest('.shopify-section');
        if (w) w.classList.toggle('rb-when-off', !show);
      }
    });
    /* a carousel that started while hidden measures again */
    if (changed && document.readyState === 'complete') window.dispatchEvent(new Event('resize'));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', check); else check();
  setInterval(check, 60000);
  document.addEventListener('visibilitychange', function () { if (!document.hidden) check(); });
  document.addEventListener('shopify:section:load', check);
  window.RbWhen = { check: check };
})();
